import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForgotPasswordMutation } from '../features/auth/api/authApiSlice';
import { useBrandTheme } from '../components/providers/brand-theme-provider.utils';

export const ForgotPasswordPage = () => {
  const { brandName } = useBrandTheme();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!email.trim()) return;
    try {
      await forgotPassword({ email: email.trim() }).unwrap();
      setSent(true);
    } catch {
      // Keep account-enumeration-safe UX: the server intentionally uses the
      // same public response for existing and non-existing addresses.
      setSent(true);
    }
  };

  return (
    <div className='flex min-h-screen flex-col justify-center bg-background px-6 py-12'>
      <div className='mx-auto w-full max-w-sm rounded-lg border bg-card px-6 py-8 text-card-foreground shadow-sm'>
        <h1 className='text-2xl font-bold'>Recuperar acceso a {brandName}</h1>
        {sent ? (
          <div className='mt-6 space-y-4'>
            <p>Si el email corresponde a una cuenta, vas a recibir un enlace para cambiar la contraseña.</p>
            <Link className='underline' to='/login'>Volver al inicio de sesión</Link>
          </div>
        ) : (
          <form className='mt-6 space-y-4' onSubmit={submit}>
            <label className='block text-sm font-medium' htmlFor='recovery-email'>Email</label>
            <input
              id='recovery-email'
              type='email'
              autoComplete='email'
              required
              value={email}
              onChange={event => setEmail(event.target.value)}
              className='w-full rounded-md border bg-background px-3 py-2'
            />
            <button
              type='submit'
              disabled={isLoading}
              className='w-full rounded-md bg-primary px-4 py-2 font-medium text-primary-foreground disabled:opacity-50'
            >
              {isLoading ? 'Enviando…' : 'Enviar enlace'}
            </button>
            <Link className='block text-center text-sm underline' to='/login'>Volver</Link>
          </form>
        )}
      </div>
    </div>
  );
};
